'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('../../styles/templates/page.scent-club-lander-scentbird.scss');

var _PageHero = require('./../components/PageHero');

var _SectionSliders = require('./../components/SectionSliders');

var _Helpers = require('../common/Helpers');

var _ValuePropsTicker = require('../components/ValuePropsTicker');

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

var forceVariation = (0, _Helpers.getUrlParameterByName)('forceVariation');

var initSlider = function initSlider() {
	if ($('[data-collection-slider]').length) {
		$('[data-collection-slider]').each(function (index, el) {
			var $slider = $(el);
			$slider.imagesLoaded(function () {
				var numOfSlides = $slider.children().length;
				if (numOfSlides > 1) {
					$slider.not('.slick-initialized').slick({
						mobileFirst: true,
						dots: false,
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						waitForAnimate: true,
						centerMode: true,
						centerPadding: '20px',
						infinite: false,
						responsive: [{
							breakpoint: 767,
							settings: {
								slidesToShow: 2,
								initialSlide: 1
							}
						}, {
							breakpoint: 991,
							settings: {
								slidesToShow: 3,
								initialSlide: 1
							}
						}, {
							breakpoint: 1199,
							settings: 'unslick'
						}]
					});
				}
			});
		});
	}
};

var addJSContent = function addJSContent() {
	var valuePropsTickerHTML = ValuePropsTicker.buildHTML();
	$(valuePropsTickerHTML).insertAfter('.hpsf-grid');
	ValuePropsTicker.init();
	$('.sc-lander-hero-scentbird').html((0, _PageHero.buildHTML)('scent-club-scentbird'));

	var countdown_el = $('.sc-lander-countdown-timer');
	var countdown_end = countdown_el.data('end-time');
	// Timer offset for date override logic primarily
	var timer_offset = 0;
	if (window.FeatureFlags) {
		timer_offset = window.FeatureFlags.internal.time - Date.now() / 1000;
	}
	if (timer_offset <= 10000) {
		timer_offset = 0;
	}
	if (countdown_end) {
		var countdown_end_date = new Date(countdown_end) - timer_offset;
		window.setInterval(function (e) {
			var diff = Math.max(Math.floor(countdown_end_date - new Date() / 1000), 0);
			var parts = [diff % 60, // secs
			Math.floor(diff / 60 % 60), // mins
			Math.floor(diff / 3600 % 3600)];
			countdown_el.html(parts.map(function (p) {
				return p.toString().padStart(2, '0');
			}).join(':'));
		}, 200);
	}

	var reversedScents = sc_monthly_scents.reverse();
	var mostRecentScents = [];

	for (var i = 0; i < reversedScents.length; i++) {

		if (mostRecentScents.length === 4) break;

		var scent = reversedScents[i];
		var product = ProductManager.getProduct(scent.id);

		if (!product) {
			continue;
		}
		if ((0, _Helpers.getProductAvailabilityType)(product) < 1) {
			continue;
		}
		if ((0, _Helpers.getMetafield)(product, 'scent_club', 'schedule').public_launch_end_time < 1629936000) {
			continue;
		}
		mostRecentScents.push(product);
	}

	var options = {
		imageType: 'second-image'
	};

	$('[data-collection-slider]').append('\n\t\t' + mostRecentScents.map(function (product) {
		return GridItem.buildHTML(product, [], options);
	}).join('') + '\n\t');

	initSlider();
};

var bindUIActions = function bindUIActions() {
	$(document).on('click', '.scent-club-landing-page a', function () {
		var href = $(this).attr('href');
		if (href === undefined || href === '#') {
			return false;
		}
		(0, _Helpers.GATrackEvent)('Click', 'Scent Club LP Link', href);
	});
	$(document).on('click', '.hpsf-index-hero a', function () {
		var href = $(this).attr('href');
		if (href === undefined || href === '#') {
			return false;
		}
		(0, _Helpers.GATrackEvent)('Click', 'Scent Club LP Hero Link', href);
	});
	$(document).on('click', '[data-donation-read-more]', function () {
		$('.hpsf-donations__logo-short-copy, .hpsf-donations__logo-full-copy').toggleClass('u-hidden');
	});

	$(window).on('resize', function () {
		initSlider();
		(0, _SectionSliders.scentBirdTestimonialSlider)();
	});
};

document.addEventListener('DOMContentLoaded', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	var render = function () {
		var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
			return _regenerator2.default.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							(0, _ValuePropsTicker.init)();
							addJSContent();
							(0, _SectionSliders.scentBirdTestimonialSlider)();

						case 3:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		return function render() {
			return _ref2.apply(this, arguments);
		};
	}();

	return _regenerator2.default.wrap(function _callee2$(_context2) {
		while (1) {
			switch (_context2.prev = _context2.next) {
				case 0:
					bindUIActions();

					ProductManager.onReady(render);

				case 2:
				case 'end':
					return _context2.stop();
			}
		}
	}, _callee2, undefined);
})));